import React from 'react';
import { Grid, Card, CardContent, Typography, Button, Box, Chip } from '@mui/material';

// Dummy data for products (apps)
const products = [
  {
    title: 'App 1 - VPN Secure',
    description: 'Secure your internet connection with our advanced VPN technology.',
    platforms: [
      { name: 'Android', url: 'https://play.google.com/store/apps/details?id=com.example.vpn' },
      { name: 'iOS', url: 'https://apps.apple.com/us/app/id1234567890' },
      { name: 'Mac', url: 'https://www.apple.com/macos/apps/' },
    ],
    imageUrl: 'https://play-lh.googleusercontent.com/gcFLUMCJ0umBfBV7mwZ0FUuMWTsdW5qkaihiTMp12fOfHfRkHW2O80_D7SLo848PPSUa=w526-h296-rw', // Updated app image URL
    productLink: '#',
  },
  {
    title: 'App 2 - Task Manager',
    description: 'An efficient task management app for organizing your work and life.',
    platforms: [
      { name: 'Android', url: 'https://play.google.com/store/apps/details?id=com.example.taskmanager' },
      { name: 'iOS', url: 'https://apps.apple.com/us/app/id987654321' },
    ],
    imageUrl: 'https://play-lh.googleusercontent.com/gcFLUMCJ0umBfBV7mwZ0FUuMWTsdW5qkaihiTMp12fOfHfRkHW2O80_D7SLo848PPSUa=w526-h296-rw', // Updated app image URL
    productLink: '#',
  },
  {
    title: 'App 3 - Cloud Storage',
    description: 'Access your files securely on the cloud from any device.',
    platforms: [
      { name: 'Android', url: 'https://play.google.com/store/apps/details?id=com.example.cloudstorage' },
      { name: 'Mac', url: 'https://www.apple.com/macos/apps/' },
      { name: 'Linux', url: 'https://www.linux.com/' },
    ],
    imageUrl: 'https://play-lh.googleusercontent.com/gcFLUMCJ0umBfBV7mwZ0FUuMWTsdW5qkaihiTMp12fOfHfRkHW2O80_D7SLo848PPSUa=w526-h296-rw', // Updated app image URL
    productLink: '#',
  },
];

const ProductSection = () => {
  return (
    <section id="products" style={{ backgroundColor: '#f0f0f0', padding: '60px 20px' }}>
      <Box sx={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
          Our Products
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {products.map((product, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ boxShadow: 5, borderRadius: 2, overflow: 'hidden', display: 'flex', flexDirection: 'column', backgroundColor: '#fff' }}>
                <img src={product.imageUrl} alt={product.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
                <CardContent sx={{ padding: '20px' }}>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {product.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" paragraph>
                    {product.description}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                    Available on:
                  </Typography>
                  <Box sx={{ display: 'flex', gap: '10px', marginBottom: 2 }}>
                    {product.platforms.map((platform, idx) => (
                      <Chip
                        key={idx}
                        label={platform.name}
                        clickable
                        component="a"
                        href={platform.url}
                        target="_blank"
                        sx={{
                          textTransform: 'capitalize',
                          backgroundColor: '#f5f5f5',
                          '&:hover': {
                            backgroundColor: '#e0e0e0',
                          },
                        }}
                      />
                    ))}
                  </Box>
                  <Button 
                    variant="text" 
                    color="primary" 
                    href={product.productLink} 
                    sx={{ textTransform: 'none', color: '#d32f2f', fontSize: '14px' }}>
                    View Details
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </section>
  );
};

export default ProductSection;
